'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _topNav = require('../actions/top-nav');

var INITIAL_STATE = {
	profileDropdownOpen: false,
	settingsDropdownOpen: false,
	mobileMenuOpen: false,
	showAvailableProfilesMobile: false
};


var topNav = function topNav(state, action) {
	switch (action.type) {
		case _topNav.TOGGLE_PROFILE_DROPDOWN:
			return Object.assign({}, state, { profileDropdownOpen: !state.profileDropdownOpen, settingsDropdownOpen: false });
		case _topNav.TOGGLE_SETTINGS_DROPDOWN:
			return Object.assign({}, state, { settingsDropdownOpen: !state.settingsDropdownOpen, profileDropdownOpen: false });
		case _topNav.TOGGLE_MOBILE_MENU:
			return Object.assign({}, state, { mobileMenuOpen: !state.mobileMenuOpen });
		case _topNav.TOGGLE_MOBILE_PROFILE_VISIBILITY:
			return Object.assign({}, state, { showAvailableProfiles: !state.showAvailableProfiles });
		case _topNav.CLOSE_ALL_MENUS:
			return Object.assign({}, state, {
				profileDropdownOpen: false,
				settingsDropdownOpen: false,
				mobileMenuOpen: false,
				showAvailableProfilesMobile: false,
				mobileSearchOpen: false,
				mobileSearchSelectedMenuItem: null,
				mobileShowRefineCategoryMenu: false,
				mobileSearchRefineCategory: null,
				mobileSearchSelectedKeyword: null,
				mobileSearchSelectedLocation: null,
				mobileSearchSelectedInsurer: { name: 'I am paying for myself' },
				mobileSearchSelectedParentSpecialty: null
			});
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = topNav;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/top-nav.js
// module id = 1685
// module chunks = 0